import {
	Directive,
	ElementRef,
	Renderer2,
	OnInit,
	OnDestroy
} from '@angular/core';

@Directive({
    selector: '.modal-header',
    standalone: false
})
export class DragModalDirective implements OnInit, OnDestroy {

	private isDragging = false;
	private startX = 0;
	private startY = 0;
	private currentX = 0;
	private currentY = 0;

	private modalContent!: HTMLElement;

	private removeMouseMove!: () => void;
	private removeMouseUp!: () => void;
	private removeMouseDown!: () => void;

	constructor(
		private el: ElementRef<HTMLElement>,
		private renderer: Renderer2
	) {}

	ngOnInit(): void {
		this.modalContent = this.el.nativeElement.closest('.modal-content') as HTMLElement;

		if (!this.modalContent) return;

		this.removeMouseDown = this.renderer.listen(
			this.el.nativeElement,
			'mousedown',
			(event: MouseEvent) => this.startDrag(event)
		);
	}

	private startDrag(event: MouseEvent): void {
		event.preventDefault();

		this.isDragging = true;

		const transform = this.modalContent.style.transform;
		const match = /translate\(([-\d.]+)px,\s*([-\d.]+)px\)/.exec(transform);

		this.currentX = match ? parseFloat(match[1]) : 0;
		this.currentY = match ? parseFloat(match[2]) : 0;

		this.startX = event.clientX - this.currentX;
		this.startY = event.clientY - this.currentY;

		this.removeMouseMove = this.renderer.listen(
			'document',
			'mousemove',
			(e: MouseEvent) => this.onDrag(e)
		);

		this.removeMouseUp = this.renderer.listen(
			'document',
			'mouseup',
			() => this.stopDrag()
		);
	}

	private onDrag(event: MouseEvent): void {
		if (!this.isDragging) return;

		this.currentX = event.clientX - this.startX;
		this.currentY = event.clientY - this.startY;

		this.renderer.setStyle(
			this.modalContent,
			'transform',
			`translate(${this.currentX}px, ${this.currentY}px)`
		);
	}

	private stopDrag(): void {
		this.isDragging = false;

		if (this.removeMouseMove) this.removeMouseMove();
		if (this.removeMouseUp) this.removeMouseUp();
	}

	ngOnDestroy(): void {
		if (this.removeMouseDown) this.removeMouseDown();
		if (this.removeMouseMove) this.removeMouseMove();
		if (this.removeMouseUp) this.removeMouseUp();
	}
}